// extracted by mini-css-extract-plugin
export default {"loginInput":"Authentication_loginInput__HkTtD","loginCheckbox":"Authentication_loginCheckbox__tbfYX"};